export const CUSTOM_BUTTON_TEXT = 'Custom';
